package mapsearch

import data.ObjectAndUserHandler
import dev.fritz2.core.invoke
import koin.koinCtx
import mapsearch.generalMarkers.connectableshapes.NewConnectableShapeConnectionStore
import mapsearch.historyPathTool.ObjectHistoryResultsCache
import org.w3c.dom.Element
import org.w3c.dom.events.Event
import org.w3c.dom.events.EventListener
import search.PathActiveHighlightedObjectMarkersStore

/**
 * Reads the currentTarget from the event and returns its id
 */
fun getTargetElementIdFromEvent(event: Event): String? {
    return (event.currentTarget as? Element)?.id
}

val markerEventListener = EventListener { event ->
    val objectAndUserHandler: ObjectAndUserHandler by koinCtx.inject()
    val newConnectableShapeConnectionStore: NewConnectableShapeConnectionStore by koinCtx.inject()
    event.stopImmediatePropagation()
    event.stopPropagation()
    newConnectableShapeConnectionStore.reset()
    objectAndUserHandler.fetchAndShowObject(objectId = getTargetElementIdFromEvent(event))
}

val userMarkerEventListener = EventListener { event ->
    val objectAndUserHandler: ObjectAndUserHandler by koinCtx.inject()
    val newConnectableShapeConnectionStore: NewConnectableShapeConnectionStore by koinCtx.inject()
    event.stopImmediatePropagation()
    event.stopPropagation()
    newConnectableShapeConnectionStore.reset()
    objectAndUserHandler.fetchAndShowUser(userId = getTargetElementIdFromEvent(event))
}

val pathToolTrackedObjectMarkerEventListener = EventListener { event ->
    val pathActiveHighlightedObjectMarkersStore: PathActiveHighlightedObjectMarkersStore by koinCtx.inject()
    event.stopImmediatePropagation()
    event.stopPropagation()
    getTargetElementIdFromEvent(event)?.let {
        pathActiveHighlightedObjectMarkersStore.selectTrackedObject(it)
    }
}

val historyMarkerEventListener = EventListener { event ->
    val objectHistoryResultsCache: ObjectHistoryResultsCache by koinCtx.inject()
    event.stopImmediatePropagation()
    event.stopPropagation()
    objectHistoryResultsCache.selectHistoryEntry(objectHistoryEntryId = getTargetElementIdFromEvent(event))
}
